import {Panel} from "primereact/panel";
import {Fieldset} from "primereact/fieldset";

export default function GeneratedPlaylistsInfo() {
    return (
        <Panel header="My Playlists Info" toggleable collapsed={false}>
            <Fieldset className={"p-0"} legend={"General"}>
                <p>Currently only for Spotify!</p>
                <div>
                    If you create an account and are logged in while generating a playlist:
                    <ul>
                        <li>
                            You will see all your playlists below.
                        </li>
                        <li>
                            You can change the title and description of your playlists.
                        </li>
                        <li>
                            You can remove the playlist from the public account. Everyone who saved the playlist will still see it in their Spotify.
                        </li>
                    </ul>
                      </div>
            </Fieldset>
        </Panel>
    )
}